import { render, staticRenderFns } from "./EditActDay-v2.vue?vue&type=template&id=08ac774d&scoped=true&"
import script from "./EditActDay-v2.vue?vue&type=script&lang=js&"
export * from "./EditActDay-v2.vue?vue&type=script&lang=js&"
import style0 from "./EditActDay-v2.vue?vue&type=style&index=0&id=08ac774d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ac774d",
  null
  
)

export default component.exports